import { LifeCycleTypes } from '@formily/react';
import { calFieldPath, calPath } from '../../utils/rPath';
import { genOnFieldValueChange } from './onFieldValueChange';
import { genGetMultiFieldsRes } from './onMultiFieldsValueChange';
import { generatorLatest } from './utils/generatorLatest';
export const genLinkedFieldProps = ($, form) => (fieldKey, deps, cb) => {
  // 这里用一个简单的锁，来保证只使用最新的值。
  const map = {};
  const generatorCb = generatorLatest(cb);

  const wrappedCb = (fieldPath, triggerFieldState) => {
    var _map$fieldPath;

    const fieldState = form.getFieldState(fieldPath);

    if (fieldState == null) {
      return;
    }

    const value = fieldState.value;
    const getMultiFieldsRes = genGetMultiFieldsRes(form);
    map[fieldPath] = ((_map$fieldPath = map[fieldPath]) !== null && _map$fieldPath !== void 0 ? _map$fieldPath : 0) + 1;
    const currentId = map[fieldPath];
    const newDeps = deps.map(path => calPath(path, fieldPath));
    generatorCb({
      value,
      ...getMultiFieldsRes(newDeps),
      triggerFieldState
    }).then(res => {
      if (currentId !== map[fieldPath]) {
        return;
      }

      form.setFieldState(fieldPath, s => {
        if (s.props == null) {
          s.props = {};
        }

        Object.keys(res).forEach(key => {
          if (key === 'value') {
            console.error('linkedFieldProps这里不要直接返回value，可以通过setFieldState设置');
            return;
          }

          s.props[key] = res[key];
        });
      });
    });
  };

  $(LifeCycleTypes.ON_FIELD_MOUNT, fieldKey).subscribe(triggerFieldState => {
    wrappedCb(triggerFieldState.name, triggerFieldState);
  });
  const onFieldValueChange = genOnFieldValueChange($, form);
  deps.forEach(key => {
    const selectKey = calPath(key, fieldKey);
    onFieldValueChange(selectKey, s => {
      const contextPath = s.name;
      wrappedCb(calFieldPath(key, contextPath, fieldKey), s);
    });
  });
};
//# sourceMappingURL=es/Form/extendsEffects/linkedFieldProps.js.map